import React, { Component } from "react";
import "./emptyPlayerCard.scss";



class EmptyPlayerCard extends Component {
  state = {
    isOnEdit: false,
    number: null,
    name: null
  };

  nameInput = React.createRef();


  handleAddPlayer = e => {
    e.stopPropagation();
    this.setState({ isOnEdit: true });
  };

  handleEditPlayerNumber = e => {
    const number = e.target.value;
    const { name } = this.state;
    if (!name && number.length === 0) {
      this.setState({ isOnEdit: false });
    } else {
      const { handleCardEdit, index } = this.props;

      let firstName = null;
      let lastName = null;
      if (name) {
        firstName = name.split(" ")[0];
        lastName = name.split(" ")[1];
      }
      this.setState({ number });
      const player = {
        accountType: "player",
        firstName: firstName,
        lastName: lastName,
        playerNumber: number
      };
      handleCardEdit(player, index);
    }
  };

  handleEditPlayerName = e => {
    const { handleCardEdit, index } = this.props;
    const { number } = this.state;
    const name = e.target.value;
    if (!number && name.length === 0) {
      this.setState({ isOnEdit: false });
    } else {
      const firstName = name.split(" ")[0];
      const lastName = name.split(" ")[1];
      this.setState({ name });
      const player = {
        accountType: "player",
        firstName: firstName,
        lastName: lastName,
        playerNumber: number
      };
      handleCardEdit(player, index);
    }
  };

  handleEnterKey = e => {
    if (e.key === "Enter") {
      console.log("enter");
      this.nameInput.focus();
    }
  };

  handleClickEmptyCard = () => {
    const { number, name } = this.state;
    if (!number && !name) {
      this.setState({ isOnEdit: false });
    }
  };

  render() {
    const { isOnEdit } = this.state;
    return (
      <div className="empty-player-card" onClick={this.handleClickEmptyCard}>
        {!isOnEdit ? (
          <button
            className="empty-player-card__plus"
            onClick={this.handleAddPlayer}
          >
            +
          </button>
        ) : (
          <div
            className="empty-player-card__edit-box"
            onClick={e => {
              e.stopPropagation();
            }}
          >
            <input
              ref={input => {
                this.numberInput = input;
              }}
              className="empty-player-card__player-input empty-player-card__player-input--number"
              placeholder={"Number"}
              onBlur={this.handleEditPlayerNumber}
              onKeyDown={this.handleEnterKey}
            />
            <input
              ref={input => {
                this.nameInput = input;
              }}
              className="empty-player-card__player-input empty-player-card__player-input--name"
              placeholder={"Name"}
              onBlur={this.handleEditPlayerName}
              onKeyDown={e =>
                e.key === "Enter" ? this.handleEditPlayerName(e) : null
              }
            />
          </div>
        )}
      </div>
    );
  }
}

export default EmptyPlayerCard;
